module.exports = __webpack_public_path__ + "static/media/cotiza-cajas-03.c48d20ca.svg";